import { Document, Property } from '../properties/properties.model';

export interface PropertyManagement {
  property: Property;
  documents: Document[];
  transactions: PropertyTransaction[];

  // Property value
  totalValue: number;
  growthOverviewChartDates: Date[];
  growthOverviewChartValues: number[];

  // Key financials
  monthlyIncome: number;
  totalRentalIncome: number;
  totalAppreciation: number;
  financialPeriod: Date;
}

export interface PropertyTransaction {
  type: WalletTransaction;
  moneyFlow: MoneyFlowType;
  date: Date;
  amount: number;
  isEditable: boolean;
}

export enum MoneyFlowType {
  INCOME = 'income',
  OUTCOME = 'outcome',
}

export enum WalletTransaction {
  // Income
  RENTAL_PAID = 'rental-paid',

  // Outcome - Property-related
  PROPERTY_TAX = 'property-tax',
  UTILITIES_PAID = 'utilities-paid',
  FURNITURE_PURCHASE = 'furniture-purchase',
  SECURITY_SERVICE = 'security-service',
  LEGAL_FEES = 'legal-fees',
  CLEANING_SERVICE = 'cleaning-service',
  MANAGEMENT_FEE = 'management-fee',
  INSURANCE_PAYMENT = 'insurance-payment',
  REPAIRS_AND_MAINTENANCE = 'repairs-and-maintenance',
  OTHER_EXPENSE = 'other-expense',

  // Outcome - Investor-related
  PROFIT_DISTRIBUTION = 'profit-distribution',
}

export const walletTransactionList: {
  name: string;
  value: WalletTransaction;
}[] = [
  { name: 'Rental paid', value: WalletTransaction.RENTAL_PAID },

  // Outcome - Property-related
  { name: 'Property tax', value: WalletTransaction.PROPERTY_TAX },
  { name: 'Utilities paid', value: WalletTransaction.UTILITIES_PAID },
  { name: 'Furniture purchase', value: WalletTransaction.FURNITURE_PURCHASE },
  { name: 'Security service', value: WalletTransaction.SECURITY_SERVICE },
  { name: 'Legal fees', value: WalletTransaction.LEGAL_FEES },
  { name: 'Cleaning service', value: WalletTransaction.CLEANING_SERVICE },
  { name: 'Management fee', value: WalletTransaction.MANAGEMENT_FEE },
  { name: 'Insurance payment', value: WalletTransaction.INSURANCE_PAYMENT },
  {
    name: 'Repairs and maintenance',
    value: WalletTransaction.REPAIRS_AND_MAINTENANCE,
  },
  { name: 'Other expense', value: WalletTransaction.OTHER_EXPENSE },

  // Outcome - Investor-related
  { name: 'Profit distribution', value: WalletTransaction.PROFIT_DISTRIBUTION },
];

export const moneyFlowTypeList: { name: string; value: MoneyFlowType }[] = [
  { name: 'Income', value: MoneyFlowType.INCOME },
  { name: 'Outcome', value: MoneyFlowType.OUTCOME },
];
